/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  AgentIDForm,
  AgentIDForm$Outbound,
  AgentIDForm$outboundSchema,
} from "../components/agentidform.js";

export type RevokeAgentSecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type RevokeAgentRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  agentIDForm: AgentIDForm;
};

/** @internal */
export type RevokeAgentSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const RevokeAgentSecurity$outboundSchema: z.ZodMiniType<
  RevokeAgentSecurity$Outbound,
  RevokeAgentSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function revokeAgentSecurityToJSON(
  revokeAgentSecurity: RevokeAgentSecurity,
): string {
  return JSON.stringify(
    RevokeAgentSecurity$outboundSchema.parse(revokeAgentSecurity),
  );
}

/** @internal */
export type RevokeAgentRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  AgentIDForm: AgentIDForm$Outbound;
};

/** @internal */
export const RevokeAgentRequest$outboundSchema: z.ZodMiniType<
  RevokeAgentRequest$Outbound,
  RevokeAgentRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    agentIDForm: AgentIDForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      agentIDForm: "AgentIDForm",
    });
  }),
);

export function revokeAgentRequestToJSON(
  revokeAgentRequest: RevokeAgentRequest,
): string {
  return JSON.stringify(
    RevokeAgentRequest$outboundSchema.parse(revokeAgentRequest),
  );
}
